const fetchData = async (
  url: string,
  options?: RequestInit,
  headers?: HeadersInit,
) => {
  const res = await global.fetch(url, {
    ...options,
    headers: {
      ...headers,
    },
  })

  const json = await res.json()

  return json
}

export { fetchData }
